import { IdLoca } from "../../utils/i18n/IdLoca";
export var mapCountryCodeToLegalInfo = new Map([
    ["US", IdLoca.purchase_tax_desc_web],
]);



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/mapCountryCodeToLegalInfo.ts
// module id = 1889
// module chunks = 3